import { styled } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

export const OneReachDataGrid = styled(DataGrid)(({ theme }) => ({
  border: 'none',
  borderRadius: 0,
  '& .MuiDataGrid-cell': {
    borderBottom: 'none',
    '&:focus': {
      outline: 'none',
    },
    '&:first-of-type': {
      paddingLeft: '24px',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    '&:focus': {
      outline: 'none',
    },
    '&:focus-within': {
      outline: 'none',
    },
    '&:first-of-type': {
      paddingLeft: '24px',
    },
  },
  '& .MuiDataGrid-iconButtonContainer': {
    visibility: 'visible',
    width: 'auto',
    button: {
      color: theme.palette.textDark.main,
    },
  },
  '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon':
    {
      opacity: 1,
      color: theme.palette.textDark.main,
    },
  '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted):hover .MuiDataGrid-sortIcon':
    {
      opacity: 1,
    },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 700,
    color: theme.palette.textDark.main,
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-row.Mui-hovered, & .MuiDataGrid-row:hover': {
    backgroundColor: 'transparent',
  },
}));
